import { IBaseMigrationItemCode } from '../../../interfaces';
import { ItemCodesMappingHandler } from '../../../mappings/item-codes';
import {
  IOasisItemCode,
  ItemCodeSourceEntity,
  OasisItemCode,
} from '../../source/entities/item-codes';

export class OasisItemCodeMappingHandler extends ItemCodesMappingHandler<
  OasisItemCode,
  ItemCodeSourceEntity
> {
  override sourceEntity = new ItemCodeSourceEntity();
  override translateFn = (record: IOasisItemCode): IBaseMigrationItemCode => ({
    ...record,
    itemCode: record.id,
    description: record.description,
  });
}
